// extracted by mini-css-extract-plugin
export default {"form":"SelectClinicForm_form__QujlQ","formButton":"SelectClinicForm_formButton__J0o-g"};